
import React, { useState, useEffect } from 'react';
// nodejs library that concatenates classes
import classnames from "classnames";
// reactstrap components
import { register } from '../api/authApiCall';
import { useNavigate } from 'react-router-dom'
// import axios from 'axios';
import {
  UncontrolledAlert,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  Label,
} from "reactstrap";
// core components
import AuthHeader from "components/Headers/AuthHeader.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import SubmitButton from './SubmitButton';
import { useTranslation } from '../i18n/context';
import PhoneInputWithCountry from './PhoneInputWithCountry';


function Register() {
  const { t } = useTranslation();
  const [focusedName, setfocusedName] = React.useState(false);
  const [focusedEmail, setfocusedEmail] = React.useState(false);
  const [focusedPassword, setFocusedPassword] = React.useState(false);
  const [focusedCompany, setfocusedCompanyName] = React.useState(false);
  const [focusedPhone, setfocusedPhone] = React.useState(false);
  const navigate = useNavigate();
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [logo, setLogo] = useState(null);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);


  const [formDataValues, setFormDataValues] = useState({
    username: '',
    user_email: '',
    password: '',
    user_phone: '',
    brandColor: '',
    company_name: '',
    serviceLevel: '',
  });

  useEffect(() => {
    const selectedServiceLevel = localStorage.getItem('selectedServiceLevel');
    if (!selectedServiceLevel) {
      navigate('service/serviceSelection');
    } else {
      setFormDataValues(prev => ({ ...prev, serviceLevel: selectedServiceLevel }));
    }
  }, [navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'user_phone') {
      if (/^\d*$/.test(value)) {
        setFormDataValues({ ...formDataValues, [name]: value });
      }
    } else {
      setFormDataValues(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  };

  const handleLogoChange = (e) => {
    // console.log(e.target.files[0])
    setLogo(e.target.files[0]);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const formData = new FormData();
    Object.entries(formDataValues).forEach(([key, value]) => {
      formData.append(key, value);
    });
    if (logo) {
      // console.log(logo)
      formData.append('logo', logo, logo.name);
    }

    try {
      const response = await register(formData);
      // console.log('Registration successful', response);
      localStorage.removeItem('selectedServiceLevel');
      setShowSuccessAlert(true);
      setTimeout(() => {
        navigate('/auth/login');
      }, 2000);
    } catch (error) {
      console.error('Registration failed', error);
      setShowErrorAlert(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <AuthHeader
        // title="E-invoice"
        image
      // lead="Create a new account."
      />
      <Container className="mt--8 pb-5">
        <Row className="justify-content-center">
          <Col lg="6" md="8">
            <Card className="bg-secondary border-0">
              <CardBody className="px-lg-5 py-lg-5">
                {showSuccessAlert && (
                  <UncontrolledAlert color="success">
                    <span className="alert-icon">
                      <i className="ni ni-like-2" />
                    </span>
                    <span className="alert-text ml-1">
                      <strong>{t('common.success')}</strong> {t('common.register')}
                    </span>
                  </UncontrolledAlert>
                )}

                {showErrorAlert && (
                  <UncontrolledAlert color="danger">
                    <span className="alert-icon">
                      <i className="ni ni-support-16" />
                    </span>
                    <span className="alert-text ml-1">
                      <strong>{t('common.error')} {t('common.wrong')}</strong>
                    </span>
                  </UncontrolledAlert>
                )}
                <div className="text-center text-muted mb-4">
                  <small>{t('common.create')}</small>
                </div>
                <Form role="form" onSubmit={handleSubmit}>
                  <FormGroup
                    className={classnames({
                      focused: focusedName,
                    })}
                  >
                    <InputGroup className="input-group-merge input-group-alternative mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-circle-08" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="text"
                        name="username"
                        value={formDataValues.username}
                        onChange={handleChange}
                        placeholder={t('common.name')}
                        required
                        onFocus={() => setfocusedName(true)}
                        onBlur={() => setfocusedName(false)}
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup
                    className={classnames({
                      focused: focusedEmail,
                    })}
                  >
                    <InputGroup className="input-group-merge input-group-alternative mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-email-83" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="email"
                        name="user_email"
                        value={formDataValues.user_email}
                        onChange={handleChange}
                        placeholder={t('common.email')}
                        required
                        onFocus={() => setfocusedEmail(true)}
                        onBlur={() => setfocusedEmail(false)}
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup
                    className={classnames({
                      focused: focusedCompany,
                    })}
                  >
                    <InputGroup className="input-group-merge input-group-alternative mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-building" />
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        type="text"
                        name="company_name"
                        value={formDataValues.company_name}
                        onChange={handleChange}
                        placeholder={t('common.company')}
                        required
                        onFocus={() => setfocusedCompanyName(true)}
                        onBlur={() => setfocusedCompanyName(false)}
                      />
                    </InputGroup>
                  </FormGroup>
                  <FormGroup
                    className={classnames({
                      focused: focusedPhone,
                    })}
                  >
                    <PhoneInputWithCountry
                      value={formDataValues.user_phone}
                      onChange={handleChange}
                      onFocus={() => setfocusedPhone(true)}
                      onBlur={() => setfocusedPhone(false)}
                      placeholder={t('common.phone')}
                    />
                  </FormGroup>
                  <FormGroup
                    className={classnames({
                      focused: focusedPassword,
                    })}
                  >
                    <InputGroup className="input-group-merge input-group-alternative">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="ni ni-lock-circle-open" />
                        </InputGroupText>
                      </InputGroupAddon>

                      <Input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={formDataValues.password}
                        onChange={handleChange}
                        placeholder={t('common.password')}
                        required
                        onFocus={() => setFocusedPassword(true)}
                        onBlur={() => setFocusedPassword(false)}
                      />
                      <InputGroupAddon addonType="append">
                        <InputGroupText
                          onClick={() => setShowPassword(!showPassword)}
                          style={{ cursor: 'pointer' }}
                        >
                          <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                        </InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                  {/* <FormGroup className="row">
                    <Col md="12">
                      <Input
                        placeholder="color"
                        id="example-color-input"
                        type="color"
                        name="brandColor"
                        value={formDataValues.brandColor}
                        onChange={handleChange}
                      />
                    </Col>
                  </FormGroup>
                  */}
                  <Label>
                    <small>{t('common.upload')}</small>
                  </Label>
                  <div className="custom-file">
                    <Input
                      className="custom-file-input"
                      placeholder='Select logo'
                      id="customFileLang"
                      lang="en"
                      type="file"
                      onChange={handleLogoChange}
                      accept="image/*"
                    />
                    <label
                      className="custom-file-label"
                      htmlFor="customFileLang"
                    >
                    </label>
                  </div>
                  <div className="text-center">
                    <SubmitButton
                      className="mt-4"
                      color="info"
                      type="submit"
                      isLoading={isSubmitting}
                    >
                      {t('common.account')}
                    </SubmitButton>
                  </div>
                </Form>
              </CardBody>
            </Card>
            <Row className="mt-3">
              <Col xs="6">
                <a
                  className="text-light"
                  href="/auth/login"

                >
                  <small
                    style={{ fontWeight: 'bolder', color: 'black' }}
                  >{t('common.loggin')}</small>
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Register;
